import { AccoCardLoading } from '@/scopes/common/components/AccoLister/AccoCard/AccoCardLoading'
import { repeat } from 'ramda'
import styles from './AccoListLoading.module.css'

export function AccoListLoading() {
  return <div className={styles.wrapper}>{repeat(<AccoCardLoading />, 7)}</div>
}
